import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Heart, Loader2 } from 'lucide-react';
import MasonryGrid from '../components/MasonryGrid';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const MyLikesPage = () => {
  const { user } = useAuth();
  const [likedImages, setLikedImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchLikedImages();
    }
  }, [user]);

  const fetchLikedImages = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE}/users/me/liked-images`, {
        withCredentials: true
      });
      setLikedImages(response.data.images || []);
    } catch (error) {
      console.error('Error fetching liked images:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-gray-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center space-x-3">
            <Heart className="w-8 h-8 text-red-500 fill-current" />
            <h1 className="text-3xl font-bold text-gray-900">My Liked Photos</h1>
          </div>
          <p className="text-gray-600 mt-2">
            {likedImages.length} photo{likedImages.length !== 1 ? 's' : ''} you have liked
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="py-8">
        {likedImages.length > 0 ? (
          <MasonryGrid images={likedImages} showPhotographer={true} />
        ) : (
          <div className="text-center py-16">
            <Heart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">No liked photos yet</h2>
            <p className="text-gray-600">
              Click the heart icon on photos you love to save them here.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyLikesPage;
